import React, { useState, useEffect } from 'react'
import { toast } from 'react-toastify'
import TableTeachers from './TableTeachers'
import { APISERVICE } from '../../../services/api.service'
import SearchTeacherByCi from './SearchTeacherByCi'
import { initialPagination } from 'data/constants'
import { ModalSubjects } from '../../shared/ModalSubjects'
import { ModalRestorePassword } from './ModalRestorePassword'

const EnableTeacher = () => {
    const [teachers, setTeachers] = useState([])
    const [isLoading, setIsLoading] = useState({ searchingTeachers: false, restoringPassword: false })
    const [pagination, setPagination] = useState(initialPagination)
    const [countSchedules, setCountSchedules] = useState([])
    const [loadingTeachers, setLoadingTeachers] = useState(false)
    const [teacherSelected, setTeacherSelected] = useState(null)
    const [isVisible, setIsVisible] = useState({ modalSubjects: false, modalConfirmRestorePwd: false })

    useEffect(() => {
        getTeachers()
    }, [])

    const show = (name) => setIsVisible((prev) => ({ ...prev, [name]: true }))
    const hide = (name) => setIsVisible((prev) => ({ ...prev, [name]: false }))
    const start = (name) => setIsLoading((prev) => ({ ...prev, [name]: true }))
    const end = (name) => setIsLoading((prev) => ({ ...prev, [name]: false }))

    const handleAction = (action, teacher) => {
        setTeacherSelected(teacher)
        if (action === 'viewSubjects') {
            show('modalSubjects')
        } else if (action === 'restorePassword') {
            show('modalConfirmRestorePwd')
        }
    }

    const getTeachers = async (pageNumber, pageSize) => {
        try {
            setLoadingTeachers(true)
            let url = 'docente/?'
            let params = `page=${pageNumber}`
            params = pageSize ? `${params}&pageSize=${pageSize}` : params
            const { success, teachers, countSchedules, pagination } = await APISERVICE.get(url, params)
            if (success) {
                setTeachers(teachers)
                setCountSchedules(countSchedules)
                setPagination(pagination)
            }
        } catch (error) {
        } finally {
            setLoadingTeachers(false)
        }
    }

    const searchDocenteByCi = async (ciTeacher) => {
        try {
            start('searchingTeachers')
            let url = 'docente/get-teacher/?'
            let params = `ciTeacher=${ciTeacher}&day=7`

            const { teacher, success } = await APISERVICE.get(url, params)
            if (success) {
                setTeachers([teacher])
                setPagination((lastState) => ({ ...initialPagination, pageSize: lastState.pageSize, totalRecords: 1 }))
                const schedulesPorcent = await APISERVICE.get(
                    'docente/get-schedules-by-teacher/?',
                    `ciTeacher=${teacher.ci}`,
                )
                setCountSchedules(schedulesPorcent)
            } else {
                setTeachers([])
            }
        } catch (error) {
        } finally {
            end('searchingTeachers')
        }
    }

    const enableTeacher = async (ciTeacher) => {
        let url = 'docente/enable-teacher/?'
        let params = `ciTeacher=${ciTeacher}&day=7`
        await APISERVICE.get(url, params)
    }

    const restorePassword = async () => {
        if (teacherSelected?.id) {
            start('restoringPassword')
            const result = await APISERVICE.post('usuario/restore-password', '', { docente_id: teacherSelected.id })
            hide('modalConfirmRestorePwd')
            if (result.success) {
                toast.success(result.message)
            } else {
                toast.error(result.message)
            }
            setTeacherSelected(null)
            end('restoringPassword')
        }
    }

    return (
        <div className='configurate-teacher'>
            <div className='contenedor title-enable-teacher fs-3'>Habilitar Docente</div>
            <SearchTeacherByCi
                getTeachers={getTeachers}
                searchDocenteByCi={searchDocenteByCi}
                setTeachers={setTeachers}
                isLoading={isLoading.searchingTeachers}
            />
            <TableTeachers
                countSchedules={countSchedules}
                teachers={teachers}
                getTeachers={getTeachers}
                pagination={pagination}
                enableTeacher={enableTeacher}
                loadingTeachers={loadingTeachers}
                handleAction={handleAction}
            />
            <ModalSubjects
                show={isVisible.modalSubjects}
                onHide={() => hide('modalSubjects')}
                header={teacherSelected?.nombre}
                teacherId={teacherSelected?.id}
            />
            <ModalRestorePassword
                show={isVisible.modalConfirmRestorePwd}
                teacher={teacherSelected?.nombre}
                onHide={() => hide('modalConfirmRestorePwd')}
                onReject={() => hide('modalConfirmRestorePwd')}
                onAccept={restorePassword}
                loading={isLoading.restoringPassword}
            />
        </div>
    )
}

export default EnableTeacher
